import { render, staticRenderFns } from "./AddPacient.vue?vue&type=template&id=0f8098bc"
import script from "./AddPacient.vue?vue&type=script&lang=js"
export * from "./AddPacient.vue?vue&type=script&lang=js"
import style0 from "./AddPacient.vue?vue&type=style&index=0&id=0f8098bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports